export default "__VITE_ASSET__CwlJL6zO__"